import React from "react";
import { useState, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import CITIES from "../../utils/cities";
import CityPicker from "../../components/cityPicker/CityPicker";
import "./publish.css";
import useTour from "../../tour/useTour";
import publishSteps from "../../tour/steps/publishSteps";
import TourButton from "../../components/tourButton/TourButton";
import { hapticSuccess } from "../../services/haptics";

const IconCar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99ZM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16Zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5ZM5 11l1.5-4.5h11L19 11H5Z"/></svg>
);

const IconHand = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12.998 2c-.552 0-1 .449-1 1v8l-1.862-.948c-.517-.264-1.152-.092-1.473.387l-.008.012c-.352.523-.18 1.235.362 1.544L13 14.5V20h5.5c.276 0 .5-.224.5-.5v-5.06c0-.155-.036-.309-.105-.447l-3.382-6.764A2 2 0 0 0 13.724 6H13V3c0-.551-.448-1-1-1Zm-6.5 12a.5.5 0 0 0-.5.5V19c0 .551.448 1 1 1h3v-6H6.498Z"/></svg>
);

const IconRoute = () => (
  <svg className="sr-publish__field-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M9.78 11.16l-1.42 1.42a7.462 7.462 0 0 1-1.02-2.68l1.98-.26c.14.82.48 1.58 1.02 2.18l-.56-.66ZM11 6l1.25-1.25c.41.52.71 1.13.89 1.79l1.92-.53c-.3-1.08-.82-2.09-1.56-2.93L12 1.5 9.37 4.13c-.74.84-1.26 1.85-1.56 2.93l1.92.53c.18-.66.48-1.27.89-1.79L11 6Zm9.54 6.26l-1.42-1.42c.54-.6.88-1.36 1.02-2.18l1.98.26c-.18.98-.56 1.91-1.14 2.72l-.44.62ZM20 13.5h-2c0 1.1-.45 2.1-1.17 2.83L12 21.16l-4.83-4.83A3.987 3.987 0 0 1 6 13.5H4c0 1.65.67 3.15 1.76 4.24L12 23.9l6.24-6.16C19.33 16.65 20 15.15 20 13.5Z"/></svg>
);

const IconClock = () => (
  <svg className="sr-publish__field-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2ZM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8Zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7Z"/></svg>
);

const IconMoney = () => (
  <svg className="sr-publish__field-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2Zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.94s4.18 1.36 4.18 3.87c0 1.92-1.37 3.07-3.12 3.37Z"/></svg>
);

const IconSeat = () => (
  <svg className="sr-publish__field-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M4 18v3h3v-3h10v3h3v-6H4v3Zm15-8h3v3h-3v-3ZM2 10h3v3H2v-3Zm15.5 0c-.28 0-.5.22-.5.5v3c0 .28.22.5.5.5h1c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5h-1ZM6 10.5v3c0 .28.22.5.5.5h1c.28 0 .5-.22.5-.5v-3c0-.28-.22-.5-.5-.5h-1c-.28 0-.5.22-.5.5ZM9 7c0-1.1.9-2 2-2h2c1.1 0 2 .9 2 2v6H9V7Z"/></svg>
);

const IconSend = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M2.01 21 23 12 2.01 3 2 10l15 2-15 2z"/></svg>
);

const Publish = ( { isLoggedIn, loginUser, onLogout } ) => {
  const [cities, setCities] = useState(["Lahore", "Islamabad", "Rawalpindi", "Karachi", "Peshawar"]);
  const [finderFormData, setFinderFormData] = useState({departure: cities[0], arrival: cities[1], route:"", estimatedDate: formatDate(new Date()), fare: { amount: "500", currency: "PKR" } });
  const [posterFormData, setPosterFormData] = useState({departure: cities[0], arrival: cities[1], route:"", estimatedDate: formatDate(new Date()), totalSeats: 1, fare: { amount: "500", currency: "PKR" }, vehicle: { model: "", color: "", plateNumber: "" }, isWomenOnly: false, preferences: { ac: false, luggage: false, flexibleTime: false } });
  // Recurring-ride template options (offers only). departureTime is taken from
  // the form's time field on submit; enabling this posts to /recurring/create.
  const [recurring, setRecurring] = useState({ enabled: false, type: "daily", daysOfWeek: [] });
  // Gender is stored as the canonical "female" string or the legacy "0" numeric code.
  const isFemaleUser = ["female", "0"].includes(String(loginUser?.gender ?? "").trim().toLowerCase());
  const [finderError, setFinderError] = useState("");
  const [posterError, setPosterError] = useState("");
  // When the "one active ride at a time" guard blocks a new post, the API returns
  // the blocking ride/request so we can link straight to it — a stale past-dated
  // offer is hidden from the feed and otherwise impossible for the user to find.
  const [blockingRideId, setBlockingRideId] = useState(null);
  const [blockingRequestId, setBlockingRequestId] = useState(null);
  const [isPosterMode, setIsPosterMode] = useState(false);
  const [editRideId, setEditRideId] = useState(null);
  // True when an admin is editing a WhatsApp-imported ride — unlocks the
  // poster-name / WhatsApp-contact fields so they can fix a wrongly-parsed number.
  const [editingImported, setEditingImported] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const { startTour } = useTour("publish", publishSteps, true);

  useEffect(()=> {
    setCities(CITIES);
    setFinderFormData((prevFormData) => ({ ...prevFormData, departure: CITIES[0], arrival: CITIES[1] }));
    setPosterFormData((prevFormData) => ({ ...prevFormData, departure: CITIES[0], arrival: CITIES[1], fare: { amount: "500", currency: "PKR" } }));
  }, [loginUser]);

  useEffect(() => {
    const editId = searchParams.get("edit");
    const repeatId = searchParams.get("repeat");
    const sourceId = editId || repeatId;
    if (sourceId) {
      if (editId) setEditRideId(editId);
      setIsPosterMode(true);
      axios.get(`/api/v1/ride/getOneRide/${sourceId}`).then((res) => {
        const r = res.data.rideWithPosterPassengerInfo;
        // For repeat: use tomorrow same time; for edit: use existing date
        const etd = repeatId
          ? formatDate(new Date(Date.now() + 24 * 60 * 60 * 1000))
          : (r.estimatedDate ? formatDate(new Date(r.estimatedDate)) : formatDate(new Date()));
        // For repeat: restore original seat count (available + booked passengers)
        const bookedCount = (r.passengerList || []).filter(p => !p.isBookingCancelled).length;
        const originalSeats = repeatId ? (r.totalSeats + bookedCount) : r.totalSeats;
        // Only an EDIT of an imported ride exposes the WhatsApp fields (a repeat
        // creates a fresh normal ride).
        setEditingImported(!!(editId && r.isImported));
        setPosterFormData({
          departure: r.departure || CITIES[0],
          arrival: r.arrival || CITIES[1],
          route: r.route === "nil" ? "" : (r.route || ""),
          estimatedDate: etd,
          totalSeats: originalSeats ?? 1,
          fare: r.fare || { amount: "500", currency: "PKR" },
          vehicle: r.vehicle || { model: "", color: "", plateNumber: "" },
          isWomenOnly: !!r.isWomenOnly,
          preferences: {
            ac: !!(r.preferences && r.preferences.ac),
            luggage: !!(r.preferences && r.preferences.luggage),
            flexibleTime: !!(r.preferences && r.preferences.flexibleTime),
          },
          posterName: r.posterName || "",
          whatsappContact: r.whatsappContact || "",
        });
      }).catch((err) => {
        console.error("Failed to load ride for editing:", err);
        setEditRideId(null);
        setPosterError(err.response?.data?.message || "Failed to load ride details. Please try again.");
      });
    }
  }, [searchParams]);

  useEffect(() => {
    if (!isLoggedIn) {
      navigate('/');
    }
  }, [isLoggedIn, navigate]);

  // Helper function to format the date
  function formatDate(date) {
    const pad = (num) => String(num).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours()+1)}:${pad(date.getMinutes())}`;
  }

  const handleFinderChange = (event) => {
    setFinderError("");
    const { name, value } = event.target;
    setFinderFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const handleRequestSubmit = async (event) => {
    event.preventDefault();
    setFinderError("");
    setBlockingRequestId(null);

    try {
      await axios.post('/api/v1/ride/createRequest/', finderFormData);
      hapticSuccess();
      navigate('/listing');
    } catch (error) {
      if (error.response && error.response.status === 401) {
        onLogout();
        navigate('/login');
      } else {
        setFinderError(error.response.data.message);
        if (error.response?.data?.blockingRequest?._id) {
          setBlockingRequestId(error.response.data.blockingRequest._id);
        }
      }
    }
  };

  const handlePosterClick = () => {
    setIsPosterMode(true);
    setFinderError("");
  };

  const handleFinderClick = () => {
    setIsPosterMode(false);
    setPosterError("");
  };

  const handlePosterChange = (event) => {
    setPosterError('');
    const { name, value } = event.target;
    setPosterFormData((prevData) => {
      if (name === 'amount') {
        return {
          ...prevData,
          fare: {
            ...prevData.fare,
            amount: value ? parseInt(value) : ''
          }
        };
      } else if (name === 'vehicleModel' || name === 'vehicleColor' || name === 'vehiclePlateNumber') {
        const vehicleField = name.replace('vehicle', '').charAt(0).toLowerCase() + name.replace('vehicle', '').slice(1);
        return {
          ...prevData,
          vehicle: {
            ...prevData.vehicle,
            [vehicleField]: value
          }
        };
      } else {
        return {
          ...prevData,
          [name]: value
        };
      }
    });
  };

  const handlePosterSubmit = async (event) => {
    event.preventDefault();
    setPosterError("");
    setBlockingRideId(null);

    try {
      if (editRideId) {
        await axios.post(`/api/v1/ride/editRide/${editRideId}?_method=PUT`, posterFormData);
        hapticSuccess();
        navigate(`/ride/${editRideId}`);
      } else if (recurring.enabled) {
        // A recurring offer is a saved template, not a single ride — the picked
        // date is irrelevant; only its time-of-day drives the schedule.
        const departureTime = posterFormData.estimatedDate.split('T')[1];
        await axios.post(`/api/v1/recurring/create`, {
          departure: posterFormData.departure,
          arrival: posterFormData.arrival,
          route: posterFormData.route,
          totalSeats: posterFormData.totalSeats,
          fare: posterFormData.fare,
          vehicle: posterFormData.vehicle,
          preferences: posterFormData.preferences,
          isWomenOnly: posterFormData.isWomenOnly,
          schedule: {
            type: recurring.type,
            daysOfWeek: recurring.daysOfWeek,
            departureTime,
          },
        });
        hapticSuccess();
        navigate('/listing');
      } else {
        await axios.post(`/api/v1/ride/createRide`, posterFormData);
        hapticSuccess();
        navigate('/listing');
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        onLogout();
        navigate('/login');
      } else {
        setPosterError(error.response.data.message);
        if (error.response?.data?.blockingRide?._id) {
          setBlockingRideId(error.response.data.blockingRide._id);
        }
      }
    }
  };

  const handlePosterDatePart = (event) => {
    const { name, value } = event.target;
    setPosterError('');
    setPosterFormData((prev) => {
      const [date, time] = prev.estimatedDate.split('T');
      const newDate = name === 'estDate' ? `${value}T${time}` : `${date}T${value}`;
      return { ...prev, estimatedDate: newDate };
    });
  };

  const handleFinderDatePart = (event) => {
    const { name, value } = event.target;
    setFinderError('');
    setFinderFormData((prev) => {
      const [date, time] = prev.estimatedDate.split('T');
      const newDate = name === 'estDate' ? `${value}T${time}` : `${date}T${value}`;
      return { ...prev, estimatedDate: newDate };
    });
  };

  const isSuccessMessage = (msg) => {
    if (!msg) return false;
    const lower = msg.toLowerCase();
    return lower.includes("success") || lower.includes("created") || lower.includes("posted");
  };

  const renderOfferForm = () => (
    <form className="sr-publish__form" onSubmit={handlePosterSubmit}>

      {/* Route */}
      <div className="sr-publish__section" data-tour="publish-route">
        <div className="sr-publish__section-label">
          <IconRoute /> Route
        </div>
        <div className="sr-publish__route-pair">
          <div className="sr-publish__route-field">
            <span className="sr-publish__route-dot sr-publish__route-dot--from" />
            <CityPicker cities={cities} value={posterFormData.departure} onChange={(city) => setPosterFormData((prev) => ({ ...prev, departure: city }))} label="From" />
          </div>
          <div className="sr-publish__route-field">
            <span className="sr-publish__route-dot sr-publish__route-dot--to" />
            <CityPicker cities={cities} value={posterFormData.arrival} onChange={(city) => setPosterFormData((prev) => ({ ...prev, arrival: city }))} label="To" />
          </div>
        </div>
      </div>

      {/* Via Route */}
      <div className="sr-publish__section">
        <div className="sr-publish__field-card">
          <div className="sr-publish__field-row">
            <IconRoute />
            <input type="text" name="route" value={posterFormData.route} onChange={handlePosterChange} placeholder="Via — e.g. Highway M-1"/>
          </div>
        </div>
      </div>

      {/* Date & Time */}
      <div className="sr-publish__section" data-tour="publish-datetime">
        <div className="sr-publish__section-label">
          <IconClock /> Departure
        </div>
        <div className="sr-publish__inline-pair">
          <div className="sr-publish__field-card">
            <div className="sr-publish__field-row">
              <input type="date" name="estDate" value={posterFormData.estimatedDate.split('T')[0]} onChange={handlePosterDatePart}/>
            </div>
          </div>
          <div className="sr-publish__field-card">
            <div className="sr-publish__field-row">
              <input type="time" name="estTime" value={posterFormData.estimatedDate.split('T')[1]} onChange={handlePosterDatePart}/>
            </div>
          </div>
        </div>
      </div>

      {/* Fare & Seats */}
      <div className="sr-publish__section" data-tour="publish-pricing">
        <div className="sr-publish__section-label">
          <IconMoney /> Pricing & Seats
        </div>
        <div className="sr-publish__inline-pair">
          <div className="sr-publish__field-card">
            <div className="sr-publish__field-row">
              <IconMoney />
              <input type="number" name="amount" min={1} value={posterFormData.fare.amount} onChange={handlePosterChange} placeholder="Fare (PKR)"/>
            </div>
          </div>
          <div className="sr-publish__field-card">
            <div className="sr-publish__field-row">
              <IconSeat />
              <select name="totalSeats" value={posterFormData.totalSeats} onChange={(e) => setPosterFormData((prev) => ({ ...prev, totalSeats: Number(e.target.value) }))}>
                <option value={1}>1 Seat</option>
                <option value={2}>2 Seats</option>
                <option value={3}>3 Seats</option>
                <option value={4}>4 Seats</option>
                <option value={5}>5 Seats</option>
                <option value={6}>6 Seats</option>
              </select>
            </div>
          </div>
        </div>
      </div>

      {/* Vehicle Details */}
      <div className="sr-publish__section" data-tour="publish-vehicle">
        <div className="sr-publish__section-label">
          <IconSeat /> Vehicle (optional)
        </div>
        <div className="sr-publish__field-card">
          <div className="sr-publish__field-row">
            <input type="text" name="vehicleModel" value={posterFormData.vehicle.model} onChange={handlePosterChange} placeholder="e.g. Toyota Corolla"/>
          </div>
        </div>
      </div>

      {/* Women-only ride — only female members may offer one (enforced server-side too). */}
      {isFemaleUser && (
        <div className="sr-publish__section">
          <label className="sr-publish__women-only">
            <input
              type="checkbox"
              checked={!!posterFormData.isWomenOnly}
              onChange={(e) => setPosterFormData((prev) => ({ ...prev, isWomenOnly: e.target.checked }))}
            />
            <span>Women-only ride <small>(only female passengers can book)</small></span>
          </label>
        </div>
      )}

      {/* Ride preferences — optional badges shown to riders. */}
      <div className="sr-publish__section">
        <div className="sr-publish__section-label">
          <IconSeat /> Preferences (optional)
        </div>
        <div className="sr-publish__prefs">
          {[
            { key: "ac", label: "AC" },
            { key: "luggage", label: "Luggage space" },
            { key: "flexibleTime", label: "Flexible timing" },
          ].map(({ key, label }) => (
            <label
              key={key}
              className={`sr-publish__pref-chip ${posterFormData.preferences[key] ? "sr-publish__pref-chip--on" : ""}`}
            >
              <input
                type="checkbox"
                checked={!!posterFormData.preferences[key]}
                onChange={(e) => setPosterFormData((prev) => ({ ...prev, preferences: { ...prev.preferences, [key]: e.target.checked } }))}
              />
              <span>{label}</span>
            </label>
          ))}
        </div>
      </div>

      {/* Recurring ride — turns this offer into a template that auto-posts on a
          schedule. Not offered when editing or repeating an existing ride. */}
      {!editRideId && !searchParams.get("repeat") && (
        <div className="sr-publish__section">
          <label className="sr-publish__women-only">
            <input
              type="checkbox"
              checked={recurring.enabled}
              onChange={(e) => setRecurring((prev) => ({ ...prev, enabled: e.target.checked }))}
            />
            <span>Make this recurring <small>(auto-post on a schedule using the time above)</small></span>
          </label>

          {recurring.enabled && (
            <div className="sr-publish__recurring">
              <div className="sr-publish__field-card">
                <div className="sr-publish__field-row">
                  <IconClock />
                  <select
                    value={recurring.type}
                    onChange={(e) => setRecurring((prev) => ({ ...prev, type: e.target.value }))}
                  >
                    <option value="daily">Every day</option>
                    <option value="weekdays">Weekdays (Mon–Fri)</option>
                    <option value="custom">Specific days</option>
                  </select>
                </div>
              </div>

              {recurring.type === "custom" && (
                <div className="sr-publish__days">
                  {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d, i) => (
                    <button
                      type="button"
                      key={d}
                      className={`sr-publish__day-chip ${recurring.daysOfWeek.includes(i) ? "sr-publish__day-chip--on" : ""}`}
                      onClick={() => setRecurring((prev) => ({
                        ...prev,
                        daysOfWeek: prev.daysOfWeek.includes(i)
                          ? prev.daysOfWeek.filter((x) => x !== i)
                          : [...prev.daysOfWeek, i],
                      }))}
                    >
                      {d}
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      )}

      {/* WhatsApp-imported ride details (admin-only edit — the parser doesn't always
          pick the poster name / number correctly). */}
      {editingImported && (
        <div className="sr-publish__section">
          <div className="sr-publish__section-label">
            <IconCar /> WhatsApp ride details
          </div>
          <div className="sr-publish__field-card">
            <div className="sr-publish__field-row">
              <input type="text" name="posterName" value={posterFormData.posterName || ""} onChange={handlePosterChange} placeholder="Poster name (as shown in WhatsApp)"/>
            </div>
          </div>
          <div className="sr-publish__field-card" style={{ marginTop: "8px" }}>
            <div className="sr-publish__field-row">
              <input type="tel" inputMode="tel" name="whatsappContact" value={posterFormData.whatsappContact || ""} onChange={handlePosterChange} placeholder="WhatsApp number e.g. 923001234567"/>
            </div>
          </div>
        </div>
      )}

      {posterError && (
        <div className={`sr-publish__error ${isSuccessMessage(posterError) ? 'sr-publish__error--success' : 'sr-publish__error--fail'}`}>
          <span>{posterError}</span>
          {blockingRideId && (
            <button type="button" className="sr-publish__error-link" onClick={() => navigate(`/ride/${blockingRideId}`)}>
              View that ride →
            </button>
          )}
        </div>
      )}

      <button type="submit" className="sr-publish__submit sr-publish__submit--offer" data-tour="publish-submit">
        <IconSend /> {editRideId ? "Save Changes" : recurring.enabled ? "Create Recurring Ride" : "Offer Ride"}
      </button>

      {!editRideId && (
        <ul className="sr-publish__rules">
          <li>You can have up to 5 upcoming rides — just keep 2+ hours between departures.</li>
          <li>Forgot to start one? It expires quietly 6 hours after departure. No penalty.</li>
          <li>Cancelling is free until 24 hours before departure; later cancellations with booked passengers count on your profile.</li>
          <li>Each passenger gets a boarding code when they book — collect the codes at pickup; the ride can only be completed once everyone is verified or marked a no-show.</li>
        </ul>
      )}
    </form>
  );

  const renderRequestForm = () => (
    <form className="sr-publish__form" onSubmit={handleRequestSubmit}>

      {/* Route */}
      <div className="sr-publish__section">
        <div className="sr-publish__section-label">
          <IconRoute /> Route
        </div>
        <div className="sr-publish__route-pair">
          <div className="sr-publish__route-field">
            <span className="sr-publish__route-dot sr-publish__route-dot--from" />
            <CityPicker cities={cities} value={finderFormData.departure} onChange={(city) => setFinderFormData((prev) => ({ ...prev, departure: city }))} label="From" />
          </div>
          <div className="sr-publish__route-field">
            <span className="sr-publish__route-dot sr-publish__route-dot--to" />
            <CityPicker cities={cities} value={finderFormData.arrival} onChange={(city) => setFinderFormData((prev) => ({ ...prev, arrival: city }))} label="To" />
          </div>
        </div>
      </div>

      {/* Via Route */}
      <div className="sr-publish__section">
        <div className="sr-publish__field-card">
          <div className="sr-publish__field-row">
            <IconRoute />
            <input type="text" name="route" value={finderFormData.route} onChange={handleFinderChange} placeholder="Via — e.g. Highway M-1"/>
          </div>
        </div>
      </div>

      {/* Date & Time */}
      <div className="sr-publish__section">
        <div className="sr-publish__section-label">
          <IconClock /> Departure
        </div>
        <div className="sr-publish__inline-pair">
          <div className="sr-publish__field-card">
            <div className="sr-publish__field-row">
              <input type="date" name="estDate" value={finderFormData.estimatedDate.split('T')[0]} onChange={handleFinderDatePart}/>
            </div>
          </div>
          <div className="sr-publish__field-card">
            <div className="sr-publish__field-row">
              <input type="time" name="estTime" value={finderFormData.estimatedDate.split('T')[1]} onChange={handleFinderDatePart}/>
            </div>
          </div>
        </div>
      </div>

      {/* Name your price: what the requester is offering to pay per seat.
          Drivers see it on the request card and can accept the trip at it. */}
      <div className="sr-publish__section">
        <div className="sr-publish__section-label">
          <IconMoney /> What you'll pay
        </div>
        <div className="sr-publish__field-card">
          <div className="sr-publish__field-row">
            <IconMoney />
            <input
              type="number"
              name="fareAmount"
              min={0}
              value={finderFormData.fare.amount}
              onChange={(e) => setFinderFormData((prev) => ({ ...prev, fare: { ...prev.fare, amount: e.target.value } }))}
              placeholder="Your fare offer (PKR)"
            />
          </div>
        </div>
      </div>

      {finderError && (
        <div className={`sr-publish__error ${isSuccessMessage(finderError) ? 'sr-publish__error--success' : 'sr-publish__error--fail'}`}>
          <span>{finderError}</span>
          {blockingRequestId && (
            <button type="button" className="sr-publish__error-link" onClick={() => navigate(`/ride/${blockingRequestId}`)}>
              View that request →
            </button>
          )}
        </div>
      )}

      <button type="submit" className="sr-publish__submit sr-publish__submit--request">
        <IconHand /> Request Ride
      </button>

      <ul className="sr-publish__rules">
        <li>You name the fare — drivers see it and decide.</li>
        <li>Any driver can tap "I can take you": you're booked onto their ride automatically and notified.</li>
        <li>You can keep up to 3 requests open; unanswered ones expire quietly after their departure time.</li>
      </ul>
    </form>
  );

  return (
    <div className="sr-publish">
      {/* ── Dark top section with rounded bottom ── */}
      <div className="sr-publish__top">
        <div className="sr-publish__top-content">
          <div className="sr-publish__header">
            <h1 className="sr-publish__title">
              {editRideId ? "Edit Ride" : searchParams.get("repeat") ? "Repeat Ride" : isPosterMode ? "Request a Ride" : "Offer a Ride"}
            </h1>
            <p className="sr-publish__subtitle">
              {editRideId
                ? "Update your ride details"
                : searchParams.get("repeat")
                  ? "Create a new ride with the same details"
                  : isPosterMode
                  ? "I need a seat and would love to join you"
                  : "I'm traveling and have seats available"
              }
            </p>
          </div>

        </div>
      </div>

      {/* ── White body section ── */}
      <div className="sr-publish__body">
        {/* Mode Toggle */}
        {!editRideId && !searchParams.get("repeat") && (
          <div className="sr-publish__toggle" data-tour="publish-toggle">
            <input type="radio" name="mode" id="mode-offer" checked={!isPosterMode} onChange={handleFinderClick} />
            <input type="radio" name="mode" id="mode-request" checked={isPosterMode} onChange={handlePosterClick} />
            <label htmlFor="mode-offer" className={`sr-publish__toggle-label ${!isPosterMode ? 'sr-publish__toggle-label--active' : ''}`} onClick={handleFinderClick}>
              <IconCar /> Offer
            </label>
            <label htmlFor="mode-request" className={`sr-publish__toggle-label ${isPosterMode ? 'sr-publish__toggle-label--active' : ''}`} onClick={handlePosterClick}>
              <IconHand /> Request
            </label>
            <div className={`sr-publish__toggle-slider ${isPosterMode ? 'sr-publish__toggle-slider--right' : ''}`} />
          </div>
        )}
        {(editRideId || searchParams.get("repeat")) ? renderOfferForm() : isPosterMode ? renderRequestForm() : renderOfferForm()}
      </div>
      <TourButton onClick={startTour} />
    </div>
  );
}

export default Publish;
